import React from "react";
import { Col, Card, CardBody } from "reactstrap";
import { useNavigate } from "react-router-dom";

const MiniWidgets = ({ reports }) => {
  const navigate = useNavigate();
  return (
    <React.Fragment>
      {reports.map((report, key) => (
        <Col key={key} md={3}>
          <Card
            style={{ cursor: report.path ? "pointer" : "default" }}
            onClick={() => {
              if (report.path) navigate(report.path);
            }}
          >
            <CardBody>
              <div className="d-flex">
                <div className="flex-1 overflow-hidden">
                  <p className="text-truncate font-size-14 mb-2">
                    {report.title}
                  </p>
                <h4 className="mb-0">
                    {report.title === "Total Revenue" || report.title === "Total Delivery Charges" || report.title === "Total Revenue COD" || report.title === "Total Revenue DTDC"
                      ? new Intl.NumberFormat("en-IN", {
                        style: "currency",
                        currency: "INR",
                      }).format(report.value)
                      : report.value}
                  </h4>
                </div>
                <div className="text-primary">
                  <i className={`${report.icon} font-size-24`}></i>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </React.Fragment>
  );
};

export default MiniWidgets;
